// extracted by mini-css-extract-plugin
export default {"frame":"InsideFrame_frame__wku+d","inbody":"InsideFrame_inbody__d5eAs"};